<div class="container">
    <div class="row">
        <div class="col-12">
            <h1>Callers Report</h1>
			<div class="row">
				<div class="col-4" style="overflow: visible; position:relative">
					<label for="">Date Range</label>
					<!-- ======================================================= -->
					<app-form-range-date
						[(ngModel)]="dateRange_"
						(OnSelected)="dateSelected($event)"
						[position]="'right'"
						[range_type]="'RANGE_PAST'"
						[autoApply]="true"
					></app-form-range-date>
				</div>
				<div class="col-8" align="left">
					<button type="button" class="btn btn-secondary waves-effect waves-light" style="bottom: 0px; position:absolute">Get Report</button>
				</div>
			</div>
        </div>
    </div>
	<div class="row">
		<div class="col-12">
			<div class="card">
				<div class="card-body">
					<input
						class="form-control"
						type="text"
						placeholder="Search"
						(keyup)="updateFilter2($event,'name')"
						/>
						<ngx-datatable
							#table
							class="material"
							[columnMode]="ColumnMode.force"
							[headerHeight]="50"
							[footerHeight]="0"
							rowHeight="auto"
							[limit]="10"
							[rows]="rows"
							[summaryRow]="true"
        					[summaryPosition]="'bottom'"
							[summaryHeight]="40"
							>
							<ngx-datatable-column name="Caller Name" prop="name" [summaryTemplate]="totalsSummary" headerClass="title-header" [width]="30"></ngx-datatable-column>
							<ngx-datatable-column name="Time in Call" prop="timeInCalls" [summaryFunc]="sumHours" headerClass="cell-center title-header" cellClass="cell-center" [width]="30">
								<ng-template let-row="row" ngx-datatable-cell-template>
									{{row.timeInCalls == 0 ? '-' : utils.formatMiliSeconds(row.timeInCalls) }}
								</ng-template>
							</ngx-datatable-column>
							<!-- <ngx-datatable-column name="Time in Screen" prop="timeInScreen" headerClass="cell-center title-header" cellClass="cell-center" [width]="30">
								<ng-template let-row="row" ngx-datatable-cell-template>
									{{row.timeInScreen == 0 ? '-' : utils.formatSeconds(row.timeInScreen)}}
								</ng-template>
							</ngx-datatable-column> -->
							<ngx-datatable-column name="Calls" prop="totalCalls" [summaryFunc]="sumValues" headerClass="cell-center title-header" cellClass="cell-center" [width]="30">
								<ng-template let-row="row" ngx-datatable-cell-template>
									{{row.totalCalls == 0 ? '-' : row.totalCalls}}
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="Total Dispos" prop="totalDispos" [summaryFunc]="sumValues" headerClass="cell-center title-header" cellClass="cell-center" [width]="30">
								<ng-template let-row="row" ngx-datatable-cell-template>
									{{row.totalDispos == 0 ? '-' : row.totalDispos}}
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="Bad Phone" prop="black" [summaryFunc]="sumValues" headerClass="cell-center title-header" cellClass="cell-center" [width]="30">
								<ng-template let-row="row" ngx-datatable-cell-template>
									{{row.black == 0 ? '-' : row.black}}
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="No Answer" prop="blue" [summaryFunc]="sumValues" headerClass="cell-center title-header" cellClass="cell-center" [width]="30">
								<ng-template let-row="row" ngx-datatable-cell-template>
									{{row.blue == 0 ? '-' : row.blue}}
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="CallBack" prop="yellow" [summaryFunc]="sumValues" headerClass="cell-center title-header" cellClass="cell-center" [width]="30">
								<ng-template let-row="row" ngx-datatable-cell-template>
									{{row.yellow == 0 ? '-' : row.yellow}}
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="Lead" prop="green" [summaryFunc]="sumValues" headerClass="cell-center title-header" cellClass="cell-center" [width]="30">
								<ng-template let-row="row" ngx-datatable-cell-template>
									{{row.green == 0 ? '-' : row.green}}
								</ng-template>
							</ngx-datatable-column>
							<!-- <ngx-datatable-column name="Other" prop="other" [summaryFunc]="sumValues" headerClass="cell-center title-header" cellClass="cell-center" [width]="30">
								<ng-template let-row="row" ngx-datatable-cell-template>
									{{row.other == 0 ? '-' : row.other}}
								</ng-template>
							</ngx-datatable-column> -->
						</ngx-datatable>
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-6">
			<div class="card">
				<div class="card-body">
					<apx-chart
					[series]="lineWithDataLabelsChart.series"
					[chart]="lineWithDataLabelsChart.chart"
					[xaxis]="lineWithDataLabelsChart.xaxis"
					[stroke]="lineWithDataLabelsChart.stroke"
					[dataLabels]="lineWithDataLabelsChart.dataLabels"
					[legend]="lineWithDataLabelsChart.legend"
					[markers]="lineWithDataLabelsChart.markers"
					[grid]="lineWithDataLabelsChart.grid"
					[yaxis]="lineWithDataLabelsChart.yaxis"
					[title]="lineWithDataLabelsChart.title"
				></apx-chart>
				</div>
			</div>
		</div>
		<div class="col-6">
			<div class="card">
				<div class="card-header">
					<h6 class="card-title">Calls and Dispos</h6>
				</div>
				<div class="card-body">
					<apx-chart
						[series]="simplePieChart.series"
						[chart]="simplePieChart.chart"
						[labels]="simplePieChart.labels"
						[legend]="simplePieChart.legend"
						[dataLabels]="simplePieChart.dataLabels"
						[responsive]="simplePieChart.responsive"
						[colors]="simplePieChart.colors"
					></apx-chart>
				</div>
			</div>
		</div>
	</div>

</div>

<ng-template #totalsSummary>
	Totals:
</ng-template>
